import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDmpjC4doIHGAmsgXeD5FsYiNT1t3TU1rs",
  authDomain: "largetransfer-3d0a3.firebaseapp.com",
  projectId: "largetransfer-3d0a3",
  storageBucket: "largetransfer-3d0a3.firebasestorage.app",
  messagingSenderId: "208661305107",
  appId: "1:208661305107:web:79d1286af7d8db14b56ce6",
  measurementId: "G-JEC0BPNX4F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export default app;
